import styled from '@emotion/styled';

const MDXStyledTable = styled.table`
  width: 100%;
  margin: 3px 0;
  border-spacing: 0;
`;

export default MDXStyledTable;
